import { z } from "zod";
import { LabeledRichTextSchema, MediaSchema } from "../../fragments";
import { LabeledNumericalPropertyValueSchema, LabeledPropertyValueListSchema, LabeledPropertyValueSchema, PropertyValueSchema, } from "../../fragments/PropertyValue";
export const RiftboundSetSchema = z.object({
    id: z.string(),
    name: z.string(),
    collectorNumberMax: z.number(),
});
export const RiftboundCardTypeSchema = z.object({
    label: z.string().optional(),
    type: z.array(PropertyValueSchema),
    superType: z.array(PropertyValueSchema).optional(),
});
export const CardProductSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const CardProductAvailabilitySchema = z.object({
    label: z.string(),
    products: z.array(CardProductSchema),
});
export const CardTagsSchema = z.object({
    label: z.string(),
    tags: z.array(z.string()).optional(),
});
export const RiftboundCardSchema = z.object({
    id: z.string(),
    collectorNumber: z.number(),
    name: z.string(),
    set: LabeledPropertyValueSchema,
    cardType: RiftboundCardTypeSchema,
    publicCode: z.string(),
    rarity: LabeledPropertyValueSchema,
    domain: LabeledPropertyValueListSchema,
    cardImage: MediaSchema,
    flags: z.array(PropertyValueSchema).optional(),
    orientation: z.enum(["portrait", "landscape"]).optional(),
    illustrator: LabeledPropertyValueListSchema,
    text: LabeledRichTextSchema.optional(),
    products: CardProductAvailabilitySchema.optional(),
    energy: LabeledNumericalPropertyValueSchema.optional(),
    might: LabeledNumericalPropertyValueSchema.optional(),
    power: LabeledNumericalPropertyValueSchema.optional(),
    tags: CardTagsSchema.optional(),
});
//# sourceMappingURL=card-data.js.map